import { Link } from "react-router-dom";
import { useConsentStore } from "@/store/consentStore";

export default function ConsentBanner() {
  const consent = useConsentStore((s) => s.analyticsConsent);
  const setConsent = useConsentStore((s) => s.setConsent);

  if (consent !== "pending") return null;

  return (
    <div className="animate-fade-in-up fixed bottom-0 left-0 right-0 z-40 border-t border-border bg-surface p-3 shadow-lg">
      <div className="mx-auto flex max-w-2xl flex-col items-center gap-2 sm:flex-row sm:justify-between">
        <p className="text-sm text-text-secondary">
          We use cookies for analytics to improve ISPYFR.{" "}
          <Link to="/privacy" className="text-primary hover:underline">
            Privacy Policy
          </Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            onClick={() => setConsent("declined")}
            className="rounded-xl border border-border px-3 py-1 text-sm font-medium text-text-secondary transition-colors hover:bg-surface-sunken hover:text-text"
          >
            Decline
          </button>
          <button
            onClick={() => setConsent("accepted")}
            className="rounded-xl bg-primary px-3 py-1 text-sm font-medium text-text-inverse transition-colors hover:bg-primary-hover"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
